
export default class {
  static getAuthHeader() {
      // return authorization header with jwt token
      let user = JSON.parse(localStorage.getItem('user'));

      if (user && user.token) {
          return "Bearer " + user.token;
      } else {
          return null;
      }
  }
  
  static saveToken(username, role, expiredPass, token) {
    localStorage.setItem('user', JSON.stringify({
      username: username,
      role: role,
      expiredPass: expiredPass,
      token: token
    }));
  }
  
  static getAuthObject() {
    const user = localStorage.getItem('user');
    
    if(user) {
      return JSON.parse(user);
    }
    else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/authtoken.js